import React from "react";
import Helmet from "react-helmet";
import { basename } from "path";
import graphql from "graphql";
import config from "../../config/siteConfig";
import SEO from "../components/seo/seo-component";
import Events from "../components/events/events";

import { Col } from "reactstrap";

import FadeIn from "../components/fade-in";
import Press from "../components/press/press.jsx";
import PageWrapper from "../components/page-wrapper/page-wrapper.jsx";
import Section from "../components/page-section/page-section.jsx";
import PageHeader from "../components/page-header/page-header.jsx";
import Img from "gatsby-image";
import "regenerator-runtime/runtime";

// find page title by path
const findNode = (path, data) =>
  data.allMarkdownRemark.edges
    .map(edge => edge.node.frontmatter)
    .filter(r => r.path === path)
    .pop();

export default function Template({ data }) {
  const { markdownRemark: page } = data;
  const path = data.markdownRemark.frontmatter.path;
  const pageNode = data.markdownRemark;
  const press = data.press.edges;
  return (
    <PageWrapper>
      <Helmet title={`${page.frontmatter.title} | ${config.siteTitle}`} />
      <SEO pagePath={path} pageNode={pageNode} pageSEO />
      <PageHeader
        title={page.frontmatter.titleLong}
        subtitle={page.frontmatter.description}
        cta={page.frontmatter.cta}
        ctaLink={page.frontmatter.ctaLink}
        backgroundImage={
          page.frontmatter.coverImage.childImageSharp.resolutions.src
        }
      />
      <FadeIn>
        <Section className="py-5">
          <Col>
            <Events />
          </Col>
        </Section>
        <Section className="bg-white pt-3 pb-3">
          <Press data={press} />
        </Section>
      </FadeIn>
    </PageWrapper>
  );
}

export const pageQuery = graphql`
  query ServicesPageByPath2($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        date(formatString: "MMMM DD, YYYY")
        title
        titleLong
        description
        cta
        ctaLink
        coverImage {
          childImageSharp {
            resize(width: 800) {
              src
            }
            resolutions(width: 1200) {
              width
              height
              src
              srcSet
            }
          }
        }
      }
    }
    press: allPressJson {
      edges {
        node {
          ...Press_list
        }
      }
    }
    allMarkdownRemark(sort: { order: ASC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          html
          frontmatter {
            title
            contentType
            date(formatString: "MMMM DD, YYYY")
            path
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/events.js